import React from 'react';
import ReactDOM from 'react-dom';

import SlidePanel from '../../components/SlidePanel';
import VariantSliderSelector from './VariantSliderSelector';

interface Props {
  open: boolean;
  onClose: () => void;
  imgUrl?: string | null;
  price?: string;
  productName?: string;
  variantName?: string;
  description?: string;
  selectedProduct;
  selectedVariant;
  onSelect: (selectedAddon: { id: string; quantity: number }) => void;
  onConfirm: (selectedOption: MultiSelectOption) => void;
  isLoading?: boolean;
  hidePrice?: boolean;
  shouldShowDiscountedPrice?: boolean;
  formattedCompareAtPrice?: string;
}

const ProductSlidePanel = ({
  open,
  onClose,
  imgUrl,
  price,
  productName,
  variantName,
  description,
  selectedProduct,
  selectedVariant,
  onSelect,
  onConfirm,
  isLoading = false,
  hidePrice = false,
  shouldShowDiscountedPrice = false,
  formattedCompareAtPrice,
}: Props): JSX.Element | null => {
  const content = (
    <SlidePanel
      open={open}
      onClose={onClose}
      imgUrl={imgUrl}
      imgs={selectedProduct?.images}
      price={price}
      comparePrice={
        shouldShowDiscountedPrice
          ? formattedCompareAtPrice || formattedCompareAtPrice
          : undefined
      }
      productName={productName}
      variantName={variantName}
      description={description}
      isLoading={isLoading}
      hasOneVariant={selectedProduct?.variants.length === 1}
      hidePrice={hidePrice}
    >
      {selectedProduct ? (
        <VariantSliderSelector
          product={selectedProduct}
          selectedVariant={selectedVariant}
          onSelect={onSelect}
          onConfirm={onConfirm}
        />
      ) : null}
    </SlidePanel>
  );

  const elementId = 'slide-panel';
  let slidePanelDiv = document.getElementById(elementId);

  if (!slidePanelDiv) {
    slidePanelDiv = document.createElement('div');
    slidePanelDiv.id = elementId;
    document.body.appendChild(slidePanelDiv);
  }

  return ReactDOM.createPortal(content, slidePanelDiv);
};

export default ProductSlidePanel;
